export default "__VITE_ASSET__k01G5ShF__"